import React from "react";
import { IonPage, IonContent, IonList, IonItem, IonGrid, IonRow, IonCol } from '@ionic/react'
import { baseUrl, cacheBust } from "../helpers/configHelper";
import "./TempDealsPage.scss";
import { formatCurrency } from "../helpers/currencyHelpers";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../store";
import { DealItem } from "../store/MenuStoreTypes";
import * as MenuItemStore from '../store/MenuItemStore';
import { useHistory } from "react-router";

interface IAppDealItemProps {
    dealSku: string;
    dealName: string;
    dealDescription?: string;
    dealImage: string;
    dealPrice: number;
    backgroundColour?: string;
}

function getImageSrc(imageUrl: string, size: number) {
    return `${baseUrl()}/images/Deals/${size}/${imageUrl}?v=${cacheBust()}`
}

function AppDealItem(props: IAppDealItemProps) {
    const dispatch = useDispatch();
    const history = useHistory();

    function handleClick() {
        dispatch(MenuItemStore.actionCreators.requestMenuItemBySku(props.dealSku, "", "", (menuItemId: number) => {
            const params = new URLSearchParams();
            params.set('page', '1');

            history.push(`/deal/${menuItemId}?${params.toString()}`);
        }));
    }
    return (
        <IonRow
            className='deal-item'
            onClick={handleClick}
        >
            <img
                alt=""
                srcSet={`
                    ${getImageSrc(props.dealImage, 600)} 600w,
                    ${getImageSrc(props.dealImage, 450)} 450w,
                    ${getImageSrc(props.dealImage, 300)} 300w,
                `}
                sizes='(min-width: 450px) 600px, (min-width: 300px) 450px, 300px'
            />
            <div className='price-container'>
                <p className="price">
                    {formatCurrency(props.dealPrice)}
                </p>
            </div>
        </IonRow>
    )
}

function TempDealsPage() {
    const deals = useSelector((state: ApplicationState) => {
        if (!state.deal?.deals) {
            console.error("Deals: No deals found.");
            return;
        }

        return state.deal.deals;
    })

    return (
        <IonPage className="deals-page-wrapper">
            <IonContent fullscreen>
                <IonGrid>
                    {deals && deals.map((d: DealItem) => {
                        return (
                            <AppDealItem
                                dealSku={d.dealSku}
                                dealName={d.title}
                                dealDescription={d.subTitle}
                                dealImage={d.imageUrl}
                                dealPrice={d.advertisedPrice}
                                backgroundColour="#613D55"
                            />
                        );
                    })}
                </IonGrid>
            </IonContent>
        </IonPage>
    )
}

export default TempDealsPage;
